export default __webpack_public_path__ + "static/media/instacart-marked.210bbc99.png";